import React from 'react'

import { Button } from 'shared'
import { Config, FormValues } from 'donate/types'
import { FormikCents, PaypalButton } from './'
import { connect } from 'formik'

export const SubmitButton = connect<{ config: Config }, FormValues>(({ formik, config }) => {
  if (formik.values.payment_method === 'paypal')
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return <PaypalButton clientId={config.paypalClientId!} />

  const loading = formik.isSubmitting || formik.values._redirecting
  const classNames = 'btn-large btn-primary submit-donation-button'

  if (formik.values.payment_method === 'direct_deposit') {
    return (
      <Button loading={loading} className={classNames} data-testid="donate-form-donate-button">
        {i18n.t('donate.submit_button.direct_deposit')}
      </Button>
    )
  }

  return (
    <Button loading={loading} className={classNames} data-testid="donate-form-donate-button">
      <span>{i18n.t('donate.submit_button.default.before_amount')}</span>
      <FormikCents fields={['amount_cents', 'codonation_cents']} />
      <span>{i18n.t('donate.submit_button.default.after_amount')}</span>
    </Button>
  )
})
